import { getRayon, getGorod } from "../../../../utilities";
export const optionInfoRepresentPersonIssuing = {
  agentSurname: {
    key: "agentSurname",
    value: "Фамилия",
    type: "text",
  },
  agentName: {
    key: "agentName",
    value: "Имя",
    type: "text",
  },
  agentMidname: {
    key: "agentMidname",
    value: "Отчество",
    type: "text",
  },
  agentDocType: {
    key: "agentDocType",
    value: "Документ",
    type: "selectSearch",
    options: [],
  },
  agentDocSeries: {
    key: "agentDocSeries",
    value: "Серия",
    type: "text",
  },
  agentDocNum: {
    key: "agentDocNum",
    value: "Номер",
    type: "text",
  },
  agentDocDate: {
    key: "agentDocDate",
    value: "Дата выдачи:",
    type: "date",
  },
  agentDocDepartment: {
    key: "agentDocDepartment",
    value: "Кем выдан",
    type: "text",
  },
  agentPersNum: {
    key: "agentPersNum",
    value: "Идент. номер",
    type: "text",
  },
  agentCountry: {
    key: "agentCountry",
    value: "Страна",
    type: "text",
    readOnly: true,
    defaultValue: "Республика Беларусь",
  },
  agentOblastId: {
    key: "agentOblastId",
    value: "Область",
    type: "selectSearch",
    isDisabled: false,
    isSearchable: false,
    options: [],
  },
  agentRayonId: {
    key: "agentRayonId",
    value: "Район",
    type: "selectSearch",
    isSearchable: true,
    disabled: true,
    options: [],
  },
  agentGorodId: {
    key: "agentGorodId",
    value: "Город",
    type: "selectSearch",
    isSearchable: true,
    disabled: true,
    options: [],
  },
  agentUlica: {
    key: "agentUlica",
    value: "Улица",
    type: "text",
    readOnly: false,
  },
  agentDom: {
    key: "agentDom",
    value: "Дом",
    type: "text",
    readOnly: false,
  },
  agentKorpus: {
    key: "agentKorpus",
    value: "Корпус",
    type: "text",
    readOnly: false,
  },
  agentKv: {
    key: "agentKv",
    value: "Квартира",
    type: "text",
    readOnly: false,
  },
  agentPhone: {
    key: "agentPhone",
    value: "Телефон",
    type: "text",
    readOnly: false,
  },
  agentDoverennost: {
    key: "agentDoverennost",
    value: "Сведения о доверенности",
    type: "text",
    readOnly: false,
  },
};

export async function setOptionsRepresentPerson(id, key) {
  if (id) {
    switch (key) {
      case "agentOblastId": {
        const rayons = await getRayon(id);
        const rayonsValid = rayons.map((item) => {
          item.key = "agentRayonId";
          return item;
        });
        optionInfoRepresentPersonIssuing.agentRayonId.options = rayonsValid;
        optionInfoRepresentPersonIssuing.agentRayonId.disabled = optionInfoRepresentPersonIssuing.agentRayonId
          .options.length
          ? false
          : true;
        optionInfoRepresentPersonIssuing.agentGorodId.options = [];
        optionInfoRepresentPersonIssuing.agentGorodId.disabled = true;
        return optionInfoRepresentPersonIssuing;
      }
      case "agentRayonId": {
        const gorod = await getGorod(id);
        const gorodValid = gorod.map((item) => {
          item.key = "agentGorodId";
          return item;
        });
        optionInfoRepresentPersonIssuing.agentGorodId.options = gorodValid;
        optionInfoRepresentPersonIssuing.agentGorodId.disabled = optionInfoRepresentPersonIssuing.agentGorodId
          .options.length
          ? false
          : true;
        return optionInfoRepresentPersonIssuing;
      }
      default:
        return optionInfoRepresentPersonIssuing;
    }
  }
}

export function setOblOptionsFromDictionaries(oblLib) {
  if (optionInfoRepresentPersonIssuing.agentOblastId.options.length === 0) {
    optionInfoRepresentPersonIssuing.agentOblastId.options.push(...oblLib);
  }
}
export function setDocOptionsFromDictionaries(docLib) {
  if (docLib.length > 0) {
    const validLib = docLib.map((item) => {
      return {
        ...item,
        key: "agentDocType",
      };
    });
    if (optionInfoRepresentPersonIssuing.agentDocType.options.length === 0) {
      optionInfoRepresentPersonIssuing.agentDocType.options.push(...validLib);
    }
  }
}
